import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  QueryList,
} from '@angular/core';
import { TabComponent } from './tab/tab.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tabs',
  template: `
    <div class="tabs-container">
      <ul class="nav nav-tabs" [ngClass]="headerClass">
        <li
          *ngFor="let tab of tabs"
          class="tab"
          [ngClass]="{ active: tab.active === true }"
          (click)="selectTab(tab)"
        >
          {{ tab.header }}
        </li>
      </ul>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent implements AfterViewChecked {
  /**
   * @description
   * Tabs is a container component to group content with tabs.
   */

  /**
   * * Content children
   * @tabs All the tabs that have been forwarded so you can list them
   */
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
  @Input() headerClass = '';

  constructor(private cdr: ChangeDetectorRef) {
    if (this.tabs) {
      this.selectTab(this.tabs.first);
      this.cdr.detectChanges();
    }
  }

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngAfterViewChecked() {
    if (this.tabs) {
      const activeTabs = this.tabs.filter((tab) => tab.active);
      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.first);
      }
    }
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  selectTab(tab: TabComponent) {
    this.tabs.toArray().forEach((tab) => (tab.active = false));
    tab.active = true;
    this.cdr.detectChanges();
  }
}
